import { ChatViewOrchestrator, type ChatViewProps } from "./ChatViewOrchestrator";

/**
 * Route-facing boundary for chat routes.
 *
 * The implementation lives in ChatViewOrchestrator so the frequently touched
 * route module stays stable and small while the orchestration internals can be
 * split into focused hooks and leaf renderers.
 *
 * Keep this file intentionally boring:
 * - route modules import the default ChatView symbol from here
 * - orchestration state lives in ChatViewOrchestrator
 * - behavior lives in focused chat/use* hooks
 * - rendering lives in chat/* leaf components
 *
 * Do not add session state, effects, provider calls, terminal logic, or composer
 * behavior here. Add those to the orchestrator or to a focused hook with tests.
 *
 * If this wrapper needs to change, keep the default export stable:
 * route ownership belongs here, but implementation ownership does not.
 * This keeps historical churn from turning route glue back into product logic.
 */
export default function ChatView(props: ChatViewProps) {
  return <ChatViewOrchestrator {...props} />;
}
